import React, { useCallback, useMemo, useEffect } from 'react';

const genericInputType = 'text';
const NUMBER_MIN = -4294967296;
const NUMBER_MAX = 4294967295;

export default function StandardInput({
  className = '',
  nameSuffix = '',
  type,
  required,
  disabled,
  name,
  value,
  id,
  focus,
  placeholder,
  onChange,
  defaultValue,
}) {
  const notGenericType = useMemo(() => ['date', 'number'].includes(type), []);

  const parseNumberInput = useCallback((numberValue) => {
    const coercedValue = parseFloat(numberValue);

    return isNaN(coercedValue) ? numberValue : coercedValue;
  }, []);

  const handleChange = useCallback((e) => {
    if (onChange) {
      onChange(
        type === 'number' ? parseNumberInput(e.target.value) : e.target.value,
      );
    }
  }, []);

  useEffect(() => {
    if (type === 'number' && value && typeof value !== 'number' && onChange) {
      onChange(parseNumberInput(value));
    }
  }, []);

  return (
    <input
      autoFocus={focus}
      className={`standardInput ${className}`}
      defaultValue={
        value === null || typeof value === 'undefined' ? defaultValue : value
      }
      disabled={disabled}
      id={id}
      name={`${name}${nameSuffix}`}
      placeholder={placeholder}
      required={required}
      type={notGenericType ? type : genericInputType}
      onChange={handleChange}
      {...(type === 'number' && {
        step: 'any',
        min: NUMBER_MIN,
        max: NUMBER_MAX,
      })}
    />
  );
}
